import { useCallback } from "react"
import { initializeErrors } from "../reducer/validationSlice"
import { useValidateRepeatableElement } from "./useValidateRepeatableElement"



export const useInitializePartiesValidations = (tabName,validationPattern,translate) => {


    const keys ={
        consignorsList:translate('CONSIGNOR'),
        consigneeList:translate('CONSIGNEE'),
        carriersList:translate('CARRIER'),
        declarantsList:translate('DECLARANT'),
        exportersList:translate('EXPORTER'),
        representativesList:translate('REPRESENTATIVE'),
        sellersList:translate('SELLER'),
        authorizationsList:translate('AUTHORIZATION'),
        additionalSupplyChainActorsList:translate('ADD_SUPPLY_CHAIN_ACTOR')
    
    }
    

    const repeatableValidationMethodsParties=useValidateRepeatableElement(tabName,validationPattern,translate)
    const initPartiesTabValidation = useCallback(() => (dispatch, getState) => {
        const parties = getState()?.actorReducer
        const headerTabErrors = getState()?.ValidationErrors?.headerTab
        const fieldPattern = validationPattern()?.[tabName]
        let errors = Object.entries(parties).reduce((prev,[key,value])=>{    
            if(Array.isArray(value) && fieldPattern[`${key}`]){
              const {validateError}=repeatableValidationMethodsParties
              const error=dispatch(validateError("actorReducer",key,`${keys[key]}`))
                   prev = {...prev,...error}
          }
        
          return prev;
                    
      },{}) || {}

      dispatch(initializeErrors({headerTab:{...headerTabErrors,...errors}}))


    }, [repeatableValidationMethodsParties])

   

    return { initPartiesTabValidation,repeatableValidationMethodsParties }
}